import { checkEnableParseJSON, formatBooleanToYesNo, formatDate } from 'components/helper/helper';
import React from 'react';
import SimpleTable from 'components/table/SimpleTable';

const ACTTestSum = (props: any) => {
  const data = {
    ...props.data,
    csu_info: checkEnableParseJSON(props?.data?.csu_info),
  };
  
  return (
    <div className="gm-summary-section2">
      <div className="gm-summary-section-title">ACT Tests</div>

      <div className="p-8">
        <div className="gm-summary-field-grid">
          <div className="gm-summary-field-item">
            <div className="gm-summary-text-primary">ACT ID number</div>
            <div className="gm-summary-text-dark">{data?.act_id_number || 'N/A'}</div>
          </div>
          
          <div className="gm-summary-field-item">
            <div className="gm-summary-text-primary">Number of past ACT scores you wish to report*</div>
            <div className="gm-summary-text-dark">{data?.number_of_act_score_report || 'N/A'}</div>
          </div>
          
          <div className="gm-summary-field-item">
            <div className="gm-summary-text-primary">Have you taken the ACT Plus Writing test?*</div>
            <div className="gm-summary-text-dark">{formatBooleanToYesNo(data?.is_have_act_score_report)}</div>
          </div>
        </div>

        <div className="gm-summary-table-section">
          <div className="gm-summary-field-label" style={{ marginBottom: '16px' }}>
            ACT Test Scores
          </div>
          <SimpleTable
            data={data?.csu_info?.act_score}
            equalColumns={true}
            column={[
              { label: 'Test Date', value: 'test_date', formatDate: true },
              { label: 'Composite', value: 'composite_score' },
              { label: 'English', value: 'english' },
              { label: 'Mathematics', value: 'mathematics' },
              { label: 'Reading', value: 'reading' },
              { label: 'Science', value: 'science' },
              {...data?.is_have_act_score_report ? { label: 'Writing', value: 'writing' } : {}},
            ]}
          />
        </div>

        <div className="gm-summary-subsection">
          <div className="gm-summary-subsection-title">Super Score</div>
          <div className="gm-summary-field-grid">
            <div className="gm-summary-field-item">
              <div className="gm-summary-text-primary">Highest Composite Score</div>
              <div className="gm-summary-text-dark">
                {data.highest_composite_score || 'N/A'}
                {data.highest_composite_test_day && (
                  <div className="gm-summary-field-label">
                    {formatDate(data.highest_composite_test_day)}
                  </div>
                )}
              </div>
            </div>

            <div className="gm-summary-field-item">
              <div className="gm-summary-text-primary">Highest English Score</div>
              <div className="gm-summary-text-dark">
                {data.highest_english_score || 'N/A'}
                {data.highest_english_test_day && (
                  <div className="gm-summary-field-label">
                    {formatDate(data.highest_english_test_day)}
                  </div>
                )}
              </div>
            </div>

            <div className="gm-summary-field-item">
              <div className="gm-summary-text-primary">Highest Mathematics Score</div>
              <div className="gm-summary-text-dark">
                {data.highest_mathematic_score || 'N/A'}
                {data.highest_mathematic_test_day && (
                  <div className="gm-summary-field-label">
                    {formatDate(data.highest_mathematic_test_day)}
                  </div>
                )}
              </div>
            </div>
            
            <div className="gm-summary-field-item">
              <div className="gm-summary-text-primary">Highest Reading Score</div>
              <div className="gm-summary-text-dark">
                {data.highest_reading_score || 'N/A'}
                {data.highest_reading_test_day && (
                  <div className="gm-summary-field-label">
                    {formatDate(data.highest_reading_test_day)}
                  </div>
                )}
              </div>
            </div>

            <div className="gm-summary-field-item">
              <div className="gm-summary-text-primary">Highest Science Score</div>
              <div className="gm-summary-text-dark">
                {data.highest_science_score || 'N/A'}
                {data.highest_science_test_day && (
                  <div className="gm-summary-field-label">
                    {formatDate(data.highest_science_test_day)}
                  </div>
                )}
              </div>
            </div>

            {data?.is_have_act_score_report && (
              <div className="gm-summary-field-item">
                <div className="gm-summary-text-primary">Highest Writing Score</div>
                <div className="gm-summary-text-dark">
                  {data.highest_writing_score || 'N/A'}
                  {data.highest_writing_test_day && (
                    <div className="gm-summary-field-label">
                      {formatDate(data.highest_writing_test_day)}
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>

        <div className="gm-summary-subsection">
          <div className="gm-summary-subsection-title">Future ACT Tests You Plan To Take</div>
          <div className="gm-summary-field-grid">
            <div className="gm-summary-field-item">
              <div className="gm-summary-text-primary">Number of future ACT sittings you expect*</div>
              <div className="gm-summary-text-dark">{data.future_act_test_plan_to_take || 'N/A'}</div>
            </div>
            
            <div className="gm-summary-field-item">
              <div className="gm-summary-text-primary">Future testing date 1</div>
              <div className="gm-summary-text-dark">
                {formatDate(checkEnableParseJSON(data.future_testing_date_1)?.test1) || 'N/A'}
              </div>
            </div>
            
            <div className="gm-summary-field-item">
              <div className="gm-summary-text-primary">Future testing date 2</div>
              <div className="gm-summary-text-dark">
                {formatDate(checkEnableParseJSON(data.future_testing_date_1)?.test2) || 'N/A'}
              </div>
            </div>
            
            <div className="gm-summary-field-item">
              <div className="gm-summary-text-primary">Future testing date 3</div>
              <div className="gm-summary-text-dark">
                {formatDate(checkEnableParseJSON(data.future_testing_date_1)?.test3) || 'N/A'}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ACTTestSum;
